import { render, staticRenderFns } from "./AccountHolderExpenseModal.vue?vue&type=template&id=e1f447b6"
import script from "./AccountHolderExpenseModal.vue?vue&type=script&lang=ts"
export * from "./AccountHolderExpenseModal.vue?vue&type=script&lang=ts"
import style0 from "./AccountHolderExpenseModal.vue?vue&type=style&index=0&id=e1f447b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports